module.exports = __webpack_public_path__ + "img/淡印黑膜.77434e91.jpg";